import { JsonObject } from '@backstage/types';
import {
  StepButton,
  StepConnector,
  Step as StepUI,
  Stepper,
  Typography,
  makeStyles,
  useTheme,
} from '@material-ui/core';
import ChevronRight from '@material-ui/icons/ChevronRight';
import DescriptionIcon from '@material-ui/icons/Description';
import Edit from '@material-ui/icons/Edit';
import { FC, MutableRefObject } from 'react';
import { AdditionalStep, Step } from '../MultiStepJsonForm/utils';

interface StepperElementProps {
  steps: Step[];
  additionalSteps?: AdditionalStep[];
  currentStep: Step | AdditionalStep | null;
  rootStepperStyle?: JsonObject;
  activeStep: number;
  ref: MutableRefObject<any>;
  setActiveStep: (index: number) => void;
  isCollapsed?: boolean;
}

const useStyles = makeStyles(
  () => ({
    // contrast button default alignText: center
    stepButton: {
      textAlign: 'left',
    },
  }),
  { name: 'StepperElement' },
);

export const StepperElement: FC<StepperElementProps> = ({
  steps,
  additionalSteps,
  currentStep,
  rootStepperStyle,
  activeStep,
  setActiveStep,
  ref,
  isCollapsed,
}) => {
  const theme = useTheme();
  const classes = useStyles();

  const { title: additionalStepTitle } = additionalSteps?.[0] || { title: '' };
  const additionalStep = (
    <StepUI
      key={additionalStepTitle}
      active={currentStep?.title === additionalStepTitle}
    >
      <StepButton
        className={classes.stepButton}
        aria-label={isCollapsed ? additionalStepTitle : ''}
        icon={
          currentStep?.title === additionalStepTitle ? (
            <Edit style={{ color: theme.palette.primary.main }} />
          ) : (
            <DescriptionIcon style={{ color: theme.palette.secondary.main }} />
          )
        }
        onClick={() => {
          setActiveStep(steps.length);
        }}
      >
        {!isCollapsed && (
          <Typography
            variant="body1"
            component="h3"
            style={{
              background:
                currentStep?.title === additionalStepTitle
                  ? theme.palette.bkg.primary
                  : 'none',
              padding: '4px',
              borderRadius: '2px',
            }}
          >
            {additionalStepTitle}
          </Typography>
        )}
      </StepButton>
    </StepUI>
  );

  return (
    <Stepper
      style={{
        background: theme.palette.background.default,
        ...rootStepperStyle,
      }}
      activeStep={activeStep}
      orientation="vertical"
      ref={ref}
      connector={<StepConnector />}
      nonLinear
    >
      {steps.map(({ title }, index) => {
        return (
          <StepUI key={title} active={currentStep?.title === title}>
            <StepButton
              className={classes.stepButton}
              aria-label={isCollapsed ? title : ''}
              icon={
                currentStep?.title === title ? (
                  <Edit style={{ color: theme.palette.primary.main }} />
                ) : (
                  <div
                    style={{
                      borderRadius: '100%',
                      background: theme.palette.bkg.primary,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                  >
                    <ChevronRight
                      style={{ color: theme.palette.secondary.main }}
                    />
                  </div>
                )
              }
              onClick={() => {
                setActiveStep(index);
              }}
            >
              {!isCollapsed && (
                <Typography
                  variant="body1"
                  component="h3"
                  style={{
                    background:
                      currentStep?.title === title
                        ? theme.palette.bkg.primary
                        : 'none',
                    padding: '4px',
                    borderRadius: '2px',
                  }}
                >
                  {title}
                </Typography>
              )}
            </StepButton>
          </StepUI>
        );
      })}
      {additionalStep}
    </Stepper>
  );
};
